var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCivil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0.267 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#111",
    stroke: "#111"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 10,
    width: 4,
    height: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 60 Q32 49 50 60Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 50,
    width: 22,
    height: 5,
    rx: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 8,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 13.5,
    width: 50,
    height: 3.5,
    rx: 1.7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16 L1 36 M11 16 L21 36 M53 16 L43 36 M53 16 L63 36",
    fill: "none",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 16,
    r: 2.4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 16,
    r: 2.4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 36 Q11 48 22 36Z M42 36 Q53 48 64 36Z",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCivil);
export default __webpack_public_path__ + "static/media/civil.17e41f284c67fcbfde592823b7a7a05d.svg";
export { ForwardRef as ReactComponent };